<script setup lang="ts">
import { useCarouselContext } from '@shared/fondof-ui/components/molecules/carousel/useCarouselContext'
import clsx from 'clsx'

const { selectedIndex, scrollTo, scrollSnaps } = useCarouselContext()

const props = defineProps<{
  dotClass?: string
  dotClassSelected?: string
  dotClassInactive?: string
}>()

const handleDotClick = (index: number) => {
  scrollTo(index)
}
</script>

<template>
  <div
    v-for="(_, index) in scrollSnaps"
    :key="index"
    :class="
      clsx([
        props.dotClass,
        index === selectedIndex
          ? props.dotClassSelected
          : props.dotClassInactive,
      ])
    "
    @click="handleDotClick(index)"
  />
</template>
